import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { toastPermissionDenied } from '../utils/permissionToast';

/**
 * Renders `children` only for a caller `check(hasPermission)` allows. Anyone else is turned
 * away the way the app's gated pages do it (a deduped toast, then a redirect), before the
 * page mounts, so it never fires requests the server would refuse.
 */
const PermissionGate = ({ check, message, redirectTo, children }) => {
  const { hasPermission } = useAuth();
  const navigate = useNavigate();
  const allowed = check(hasPermission);

  useEffect(() => {
    if (!allowed) {
      toastPermissionDenied(message);
      navigate(redirectTo, { replace: true });
    }
  }, [allowed, message, redirectTo, navigate]);

  return allowed ? children : null;
};

export default PermissionGate;
